import script from "./FileMoveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileMoveModal.vue?vue&type=script&setup=true&lang=ts"

import "./FileMoveModal.vue?vue&type=style&index=0&id=761c61ed&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761c61ed"]])

export default __exports__